import { c as _c } from "react/compiler-runtime";
import type { CalendarDate } from '@internationalized/date';
import type { CalendarState, RangeCalendarState } from '@react-stately/calendar';
import type { ReactNode } from 'react';
export const Row = t0 => {
  const $ = _c(7);
  const {
    state,
    startDate,
    weekIndex,
    children
  } = t0;
  let t1;
  if ($[0] !== children || $[1] !== startDate || $[2] !== state || $[3] !== weekIndex) {
    t1 = state.getDatesInWeek(weekIndex, startDate).map(children);
    $[0] = children;
    $[1] = startDate;
    $[2] = state;
    $[3] = weekIndex;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== t1) {
    t2 = <tr className="grid grid-cols-7 py-0.5">{t1}</tr>;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};